import request from '@/http'
export const apiTeamDetail = {
  /** @name 工队详情页-获取工队人员列表 */
  getTeamMembers: (data) => request.get(`/teamMembers/list`, data),
  /** @name 工队详情页-获取专业设备列表 */
  getEquipment: (data) => request.get(`/equipment/front`, data),
  /** @name 工队详情页-获取工程业绩列表 */
  // getTeamResultsList: (data) => request.get(`/teamResults/list`, data),
  getTeamResultsList: (data) => request.post(`/teamResults/getJybResultList`, data),
  /** @name 工队详情页-获取专项资质 */
  GetAptitudeList: (parms) => request.post(`/teamResults/getJybAptitudeList`, parms),
  /** @name 工队详情页-获取相册20210309 */
  GetfindAlbumByTeamNo: (parms) => request.get(`/album/list`, parms),
  /** @name 工队详情页-获取相册20210908 */
  GetTeamPhoto: (no) => request.get(`/album/findAlbumListByTeamNo?no=${no}`),
  /** @name 工队详情页-获取施工风采视频 */
  GetVideos: (parms) => request.get(`/team/video/page`, parms),
  /** @name 更新视频播放次数 */
  GetVideoCount: (no) => request.get(`/team/video/update/count/${no}`),
  /** @name 获取团队成员详情 */
  getTeamMembersDetail:(data)=>request.get(`/teamMembers/detailTeamMember?no=${data}&status=2`),
  /** @name 获取工程业绩详情 */
  getPerformanceDetail : data => request.get(`/teamResults/detailTeamResults?no=${data}`),
  /** @name 获取专业设备详情 */
  getEquipmentDetail : (data) => request.get(`/equipment/detailByTeamEquipmentNo?no=${data}`),
}
